import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import router from './router';
import createPersistedState from 'vuex-persistedstate';
import { getData } from './api';

Vue.use(Vuex);

if (process.env.NODE_ENV === 'development') {
    axios.defaults.withCredentials = true;
}

export default new Vuex.Store({
    state: {
        accessToken: null,
        loggingIn: false,
        loginError: null,
        user: {},
    },
    mutations: {
        loginStart: (state) => (state.loggingIn = true),
        loginStop: (state, errorMessage) => {
            state.loggingIn = false;

            if (errorMessage === 'invalid_credentials') {
                state.loginError = 'Deze gegevens zijn incorrect';
            } else if (!errorMessage) {
                state.loginError = 'Er is een onbekende fout opgetreden';
            } else {
                state.loginError = errorMessage;
            }
        },
        updateAccessToken: (state, accessToken) => {
            state.accessToken = accessToken;
        },
        updateUser: (state, user) => {
            state.user = user;
        },
        logout: (state) => {
            state.accessToken = null;
        },
    },
    actions: {
        doLogin({ commit }, _data) {
            commit('loginStart');
            axios({
                url: process.env.VUE_APP_API_URL + '/oauth/token',
                withCredentials: false,
                data: {
                    grant_type: process.env.VUE_APP_GRANT_TYPE,
                    client_id: process.env.VUE_APP_CLIENT_ID,
                    client_secret: process.env.VUE_APP_CLIENT_SECRET,
                    provider: process.env.VUE_APP_PROVIDER,
                    username: _data.username,
                    password: _data.password,
                },
                method: 'POST',
            })
                .then((response) => {
                    localStorage.setItem(
                        'accessToken',
                        response.data.access_token
                    );
                    commit('loginStop', null);
                    commit('updateAccessToken', response.data.access_token);
                    router.push({ name: 'admin' });
                })
                .catch((error) => {
                    commit(
                        'loginStop',
                        error.response && error.response.data.error
                    );
                    commit('updateAccessToken', null);
                });
        },
        fetchAccessToken({ commit }) {
            commit('updateAccessToken', localStorage.getItem('accessToken'));
        },
        logout({ commit }) {
            localStorage.removeItem('accessToken');
            commit('logout');
            router.push('/login');
        },
    },
    plugins: [createPersistedState()],
});
